class ProductFamily extends HTMLElement {
    constructor() {
        super();
        var self = this;
        this.pdpF = document.querySelector('.products-option-family');
        this.btnAddToFamily = document.querySelector('.btn-family');
        this.idParent = document.getElementById('id-product-parent').value;
        this.cartDrawer = document.getElementById('cart-drawer')
        this.notification = document.getElementById('mess-notification')
        this.btnAddToFamily.addEventListener('click', function (el) {
            let status = self.checkQtyVariantSelected()
            if(self.btnAddToFamily.getAttribute('data-status') == 'true') {
                if(status) {
                    self.addFamilyToCart(this, el)
                } else {
                    self.showNotification(window.errorQty, 'error')
                }
            } else {
                if(!status) {
                    self.showNotification(window.errorQty, 'error')
                } else {
                    self.showNotification(window.errorOption, 'error')
                }
            }
        })
        this.addEventPlusMinus()
        this.addEventChangeSelectVariants()
    }

    checkQtyVariantSelected() {
        let status = true
        document.querySelectorAll('.variant-option.error').forEach(item => {
            item.classList.remove('error')
        })

        this.pdpF.querySelectorAll('.product-option').forEach(option => {
            option.querySelectorAll('.input-variant:checked').forEach(item => {
                let variantOption = item.closest('.variant-option');
                let qty = Number(variantOption.querySelector('.action-qty').querySelector('input').value);
                if(qty == 0) {
                    status = false
                    variantOption.classList.add('error')
                }
            })
        })
        return status
    }

    addEventPlusMinus() {
        let self = this;
        let optionVariant = this.pdpF.querySelectorAll('.product-option');
        optionVariant.forEach(option => {
            let variants = option.querySelector('.variants')
            let variantsOptions = variants.querySelectorAll('.variant-option')
            variantsOptions.forEach(variantsOption => {
                if(variantsOption.getAttribute('data-available') == "true") {
                    let actionQty = variantsOption.querySelector('.action-qty')
                    actionQty.querySelector('.icon-minus').addEventListener('click', function (el) {
                        self.changeQty(el,option,variantsOption,'minus')
                    })
                    actionQty.querySelector('.icon-plus').addEventListener('click', function (el) {
                        self.changeQty(el,option,variantsOption,'plus')
                    })
                }
            })
        })
    }

    changeQty(el,option,variantsOption,type) {
        let self = this;
        let qtyAction = el.target.closest('.action-qty').querySelector('.value-qty');
        let titleVariant = el.target.closest('.action-qty').closest('.variant-option').querySelector('.title-variant ')
        let input = qtyAction.querySelector('input');
        let label = qtyAction.querySelector('label');
        let valueQty = Number(input.value);
        let valueNew = 0;
        let iconMinus = el.target.closest('.action-qty').querySelector('.icon-minus');
        if(type == 'plus') {
            valueNew = valueQty + 1;
            iconMinus.classList.remove('disable');
            if(variantsOption.getAttribute('data-is-add') == 'false') {
                variantsOption.setAttribute('data-is-add', 'true')
            }
            if(titleVariant.querySelector('input').checked == false) {
                titleVariant.querySelector('input').checked = true;
            }
        } else {
            if(valueQty == 0) {return}
            valueNew = valueQty - 1;
            if(valueNew == 0 ){
                iconMinus.classList.add('disable');
                variantsOption.setAttribute('data-is-add', 'false');
                if(titleVariant.querySelector('input').checked == true) {
                    titleVariant.querySelector('input').checked = false;
                }
            }

        }
        input.value = valueNew
        label.innerHTML = valueNew

        let totalQty = 0
        option.querySelectorAll('.input-variant:checked').forEach(item => {
            let variantOption = item.closest('.variant-option')
            let valueInput = variantOption.querySelector('.action-qty').querySelector('input').value
            totalQty += Number(valueInput)
        })
        option.setAttribute('data-total-value', totalQty)
        self.checkConditions()
        self.changePriceParent()
    }

    changePriceParent() {
        let totalPriceCurrent = 0, totalPriceWas = 0;
        this.pdpF.querySelectorAll('.product-option').forEach(option => {
            let priceFamily = option.querySelector('.price-family')
            let priceCurrent = priceFamily.querySelector('.price__default').querySelector('.price__current')
            let priceWas = priceFamily.querySelector('.price__default').querySelector('.price__was')

            priceCurrent = priceCurrent.innerHTML == '' ? '0' : priceCurrent.innerHTML
            priceWas = priceWas.innerHTML == '' ? '0' : priceWas.innerHTML


            priceCurrent = parseFloat(priceCurrent.replace(window.symbol, '').replace('\n', '').replace(',', '.'));
            priceWas = parseFloat(priceWas.replace(window.symbol, '').replace('\n', '').replace(',', '.'));

            option.querySelectorAll('.input-variant:checked').forEach(inputChecked => {
                let variantOption = inputChecked.closest('.variant-option');
                let qty = variantOption.querySelector('.action-qty').querySelector('input').value
                let priceCurrentNew = priceCurrent * qty
                let priceWasNew = priceWas * qty
                totalPriceCurrent += priceCurrentNew
                totalPriceWas += priceWasNew
            })
            console.log(totalPriceWas)
        });

        document.querySelectorAll('.product-info__price').forEach(item => {
            let priceCurrent = item.querySelector('.price__default').querySelector('.price__current')
            let priceWas = item.querySelector('.price__default').querySelector('.price__was')
            if(totalPriceWas > 0 ) {   
                priceWas.innerHTML = totalPriceWas.toFixed(2) + window.symbol
             }
            else{
                priceWas.innerHTML = ''
            }
            if(totalPriceCurrent > 0 ) {
                priceCurrent.innerHTML = totalPriceCurrent.toFixed(2) + window.symbol
            } else {
                priceCurrent.innerHTML = '0,00' + window.symbol
            }
        })
    }

    checkConditions() {
        let status = true
        this.pdpF.querySelectorAll('.product-option').forEach(item => {
            if(Number(item.getAttribute('data-total-value')) <= 0 ){
                status = false
                return
            }
        });
        // Alaway set true => dont need select all option of product family to add to cart 
        this.btnAddToFamily.setAttribute('data-status', true)
    }

    showNotification(mess, type) {
        if(this.notification)  {
            let self = this
            let time_show = Number(this.notification.getAttribute('data-time-show')) * 1000
            this.notification.classList.add(type)
            this.notification.classList.remove('hidden')
            this.notification.querySelector('span').innerHTML = mess
            setTimeout(function () {
                self.notification.classList.add('hidden')
                self.notification.classList.remove(type)
                self.notification.querySelector('span').innerHTML = ''
            },time_show)
        }
    }

    async addFamilyToCart(button,el) {
        el.preventDefault();
        let self = this;
        let items = [];
        let idPackId = 'packFamilyId_' + Date.now();
        let totalQty = 0;
        this.pdpF.querySelectorAll('.product-option').forEach(item => {
            totalQty = totalQty + Number(item.getAttribute('data-total-value'))
        })
        //Add product parent
        // items.push({
        //     'id': this.idParent,
        //     'quantity': 1
        //     // 'properties': {_packId: idPackId, _packItemType: "parent", _packSize: totalQty}
        // })
        this.pdpF.querySelectorAll('.product-option').forEach(option => {
            option.querySelectorAll('.input-variant:checked').forEach(item => {
                let variantOption = item.closest('.variant-option');
                let variantId = variantOption.getAttribute('data-id');
                let qty = variantOption.querySelector('.action-qty').querySelector('input').value;
                items.push({
                    'id': variantId,
                    'quantity': Number(qty)
                    // 'properties': {_packId: idPackId, _packItemType: "child", _packSize: totalQty}
                })
            })
        })

        let itemsNew = items.reverse()
        await self.addToCart({
            'items': itemsNew,
            'sections': this.getSectionsToRender().map((section) => section.section),
            'sections_url': window.location.pathname
        }, button)
    }

    async addToCart(data, button) {
        let bodyData = JSON.stringify(data);
        let self = this;
        button.classList.add('is-loading');
        if(button.querySelector('span')) {
            button.querySelector('span').style.visibility = 'hidden'
        }
        await fetch('/cart/add.js', {
            body: bodyData,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            },
            method: 'POST'
        }).then(function (response) {
            return response;
        }).then(async function (response) {
            let data = await response.json();
            if (!response.ok) {
                self.showNotification(data.description, 'error')
                return;
            };

            if (theme.settings.afterAtc === "page") {
                setTimeout(() => {
                    window.location.href = theme.routes.cart;
                }, 300);
            } else {
                const quickAddDrawer = self.closest("quick-add-drawer") || document.querySelector('quick-add-drawer');
                if (quickAddDrawer) quickAddDrawer.addedToCart();

                setTimeout(() => {
                    // Update cart drawer contents.
                    if (self.cartDrawer) {
                        self.cartDrawer.renderContents(
                            data,
                            !quickAddDrawer && theme.settings.afterAtc === "drawer"
                        );
                    } else if (window.location.pathname === theme.routes.cart) {
                        const cartItems = document.querySelector("cart-items");
                        if (cartItems) {
                            if (cartItems.dataset.empty === "true") {
                                window.location.reload();
                            } else {
                                cartItems.refresh();
                            }
                        }
                    }
                    document.getElementById('cart-icon').click();
                    button.classList.add('is-success');
                }, 700);
            }
        }).catch(function (err) {
            console.log(err)
        }).finally(async () => {
            button.classList.remove('is-success');
            button.classList.remove('is-loading');
            button.querySelector('span').style.visibility = 'visible'
        });
    }

    updateCartIcon(response) {
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble) {
            cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
        }
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        let sections = [
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'free-shipping-notice',
                section: 'free-shipping-notice',
                selector: '.free-shipping-notice'
            }
        ];

        if (this.cartDrawer) {
            const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
            sections = [
                ...sections,
                {
                    id: 'cart-items',
                    section: cartDrawerId,
                    selector: 'cart-items'
                },
                {
                    id: 'cart-promoted-products',
                    section: cartDrawerId,
                    selector: '#cart-promoted-products'
                },
                {
                    id: 'cart-drawer',
                    section: cartDrawerId,
                    selector: '.cart-drawer__summary'
                },
                {
                    id: 'cart-drawer-media-promotion',
                    section: cartDrawerId,
                    selector: '#cart-drawer-media-promotion'
                }
            ];
        } else {
            sections = [
                ...sections,
                {
                    id: 'cart-items',
                    section: this.dataset.section,
                    selector: 'cart-items'
                },
                {
                    id: 'cart-summary',
                    section: document.getElementById('cart-summary').dataset.section,
                    selector: '.cart__summary'
                }
            ];
        }

        return sections;
    }

    addEventChangeSelectVariants() {
        let self = this;
        this.pdpF.querySelectorAll('.input-variant').forEach(item => {
            item.addEventListener('change', function (el) {
                let totalQty = 0
                let parent = el.target.closest('.product-option');
                parent.querySelectorAll('.input-variant:checked').forEach(item => {
                    let variantOption = item.closest('.variant-option')
                    let valueInput = variantOption.querySelector('.action-qty').querySelector('input').value
                    totalQty += Number(valueInput)
                })
                parent.setAttribute('data-total-value', totalQty)
                self.checkConditions()
                self.changePriceParent()
            })
        })
    }
}
customElements.define('product-family', ProductFamily)

class availableNumber extends HTMLElement {
    constructor() {
        super();
        this.cardItems = this.querySelectorAll('.variants .available-number');
        this.maxWidth = 0;
        this.calculatemaxWidth();
        this.setCardItemHeight();
    }
    calculatemaxWidth() {
        this.maxWidth = 0;
        this.cardItems.forEach(cardItem => {
            const height = cardItem.offsetWidth;
            this.maxWidth = Math.max(this.maxWidth, height);
        });
    }
    setCardItemHeight() {
        this.cardItems.forEach(cardItem => {
            cardItem.style.setProperty('--card-item', `${this.maxWidth}px`);
        });
    }
}
customElements.define('available-number', availableNumber);

